var $d526589172914c62$exports = {};
$d526589172914c62$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "colorSwatch": `amostra de cores`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};


export {$d526589172914c62$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
